import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import useCSRFToken from 'hooks/use-csrf-token';

import type { Response } from '../types';

import client from '../client';

type UseCancelJobsInput = { jobs: Array<number>; reason?: string };

const useCancelJobs = (
  callBack?: () => void,
): UseMutationResult<Response, string, UseCancelJobsInput, unknown> => {
  const csrfToken = useCSRFToken();
  const mutation = useMutation<Response, string, UseCancelJobsInput, unknown>(
    'cancel-jobs',
    async (params: UseCancelJobsInput) => {
      const payload: Record<string, Array<number> | string> = {
        jobs: params.jobs,
      };
      if (params.reason) {
        payload.reason = params.reason;
      }
      const response = await fetch('/api/job/bulk/cancel/', {
        body: JSON.stringify(payload),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        method: 'POST',
      });
      if (response.ok) return response.json();
      throw new Error('Something went wrong');
    },
    {
      onSuccess: () => {
        const queriesToInvalidate = [
          'organization-jobs',
          'paginated-organization-jobs',
          'job-details',
        ];
        queriesToInvalidate.forEach((query) => {
          client.invalidateQueries(query);
        });
        callBack?.();
      },
    },
  );
  return mutation;
};

export default useCancelJobs;
